import { FormattedMessage, useIntl } from "react-intl";
import { RegistrationCreateDto } from "../../../openapi/edsn-webapi";
import { safePropertyMap } from "../../../utils";
import { Alert, Box } from "@mui/material";
import { nameValidator, phoneValidator } from "../../../validators";
import { InputControl } from "../../common";

export const DvtContactStep = () => {
  const map = safePropertyMap<RegistrationCreateDto>();
  const intl = useIntl();

  return (
    <Box sx={{ position: "relative" }}>
      <Alert severity="info">
        <FormattedMessage id="dvtContactInformation" />
      </Alert>
      <InputControl
        required
        label="firstname"
        name={map(`dvtContact.initials`)}
        validate={{
          maxLength: (value) =>
            !value || value.length <= 16 || "firstNameMaxLength",
          validName: nameValidator,
        }}
      />
      <InputControl
        required
        label="lastname"
        name={map(`dvtContact.lastName`)}
        validate={nameValidator}
      />
      <InputControl
        required
        pattern={{
          value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
          message: intl.formatMessage({ id: "invalidEmailAddress" }),
        }}
        type="email"
        label="email"
        name={map(`dvtContact.emailAddress`)}
      />
      <InputControl
        required
        validate={phoneValidator}
        placeholder="+31612345678"
        label="phoneNumber"
        name={map(`dvtContact.telephone`)}
      />
    </Box>
  );
}